import { dateFormatNoTimeZone } from 'common/helpers/dateHelper';

export const getFirstProducts = (items, club, productReducer) => {
  let firstProduct;
  let firstDate;

  items.forEach((item) => {
    const clubItem = club.controlledSubscription.items.find(
      (i) => i.sku === item.sku
    );
    if (clubItem) {
      const { productId } = clubItem;
      if (productReducer?.[productId]) {
        const product = productReducer?.[productId];
        const { metaData } = product;
        if (metaData && metaData['club-release-date']) {
          if (!firstDate) {
            firstDate = metaData['club-release-date'];
            firstProduct = item.productTitle;
          }
          if (metaData['club-release-date'] < firstDate) {
            firstDate = metaData['club-release-date'];
            firstProduct = item.productTitle;
          }
        }
      }
    }
  });

  if (firstDate) {
    firstDate = dateFormatNoTimeZone(firstDate, 'darioushLong');
  }

  return { firstProduct, firstDate };
};
